module.exports = __webpack_public_path__ + "img/corporate-business.b0a6276f.png";